import { useState } from 'react';
import { createPortal } from 'react-dom';
import { useNavigationAction } from './NavigationContext';

// Renders children as a nested view inside the mobile More dialog.
export default function EmbeddedNavigationView({ parent, show, title, onClose, children }) {
  const [host, setHost] = useState(null);
  useNavigationAction(`modal-${parent}`, show ? {
    label: title,
    parent,
    onClick: onClose,
    renderContent: () => <div ref={setHost} className="mobile-tool-detail" />,
  } : null);
  return show && host ? createPortal(children, host) : null;
}
